import React from 'react';
import PropTypes from 'prop-types';

import LoadingIndicator from './LoadingIndicator';
import { Typography } from '@material-ui/core';
import { withNamespaces } from 'react-i18next';

const LoadingOrError = props => {
  const { loading, error, noData, errorMessage, t } = props;
  const classes = props.classes || {};

  if (!loading && !error && !noData) return null;

  return (
    <div className={classes.root}>
      {loading && <LoadingIndicator className={classes.loading} />}
      {!loading && error && (
        <Typography className={classes.error}>
          {errorMessage || t('Uh oh.  Something went wrong loading your data.')}
        </Typography>
      )}
      {!loading && noData && (
        <Typography className={classes.nodata}>
          {errorMessage || t('No data to display')}
        </Typography>
      )}
    </div>
  );
};

LoadingOrError.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.bool,
  noData: PropTypes.bool,
  errorMessage: PropTypes.string,
  classes: PropTypes.object
};

export default withNamespaces()(LoadingOrError);
